import React, { useState, useEffect } from 'react';
import { useMap } from '../../context/MapContext';
import './MapLegend.css';

function LegendItem({ layer }) {
  const [open,    setOpen]    = useState(true);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(false);

  const legendUrl = `/api/wms-proxy?url=${encodeURIComponent(
    `${layer.baseUrl}?SERVICE=WMS&REQUEST=GetLegendGraphic` +
    `&VERSION=${layer.version}&LAYER=${layer.layers}` +
    `&FORMAT=image/png` +
    // LEGEND_OPTIONS em maiúsculas (GeoServer é case-sensitive em algumas versões).
    // forceLabels:on  → força a renderização do <Title> de cada <Rule> do SLD como texto.
    // hideEmptyRules:true → omite regras sem feições visíveis (legenda mais limpa).
    `&LEGEND_OPTIONS=forceLabels:on;fontName:Arial;fontSize:12;fontAntiAliasing:true;bgColor:0xFFFFFF;dpi:96;hideEmptyRules:true`
  )}`;

  // Reset error/loading when layer changes
  useEffect(() => {
    setError(false);
    setLoading(true);
  }, [legendUrl]);

  return (
    <div className="ml-item">
      <button
        className={`ml-item-header${open ? ' ml-item-header--open' : ''}`}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="ml-item-name" title={layer.name}>{layer.title || layer.name}</span>
        <svg
          className={`ml-item-chevron${open ? ' ml-item-chevron--open' : ''}`}
          width="12" height="12" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2.5"
          strokeLinecap="round" strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className="ml-item-body">
          {loading && !error && (
            <div className="ml-spinner-row">
              <span className="ml-spinner" />
            </div>
          )}
          {error ? (
            <p className="ml-error">Legenda indisponível</p>
          ) : (
            <div className="ml-img-scroll">
              <img
                key={legendUrl}
                src={legendUrl}
                alt={`Legenda ${layer.name}`}
                className="ml-img"
                onLoad={() => setLoading(false)}
                onError={() => { setLoading(false); setError(true); }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function MapLegend() {
  const { wmsLayers } = useMap();
  const [collapsed, setCollapsed] = useState(false);

  const visibleLayers = wmsLayers
    .filter((l) => l.visible)
    .sort((a, b) => a.order - b.order);

  if (visibleLayers.length === 0) return null;

  return (
    <div className={`map-legend${collapsed ? ' map-legend--collapsed' : ''}`}>
      {/* Panel header */}
      <div className="ml-header">
        <svg className="ml-header-icon" width="13" height="13" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2.5"
          strokeLinecap="round" strokeLinejoin="round">
          <line x1="8"  y1="6"  x2="21" y2="6"  />
          <line x1="8"  y1="12" x2="21" y2="12" />
          <line x1="8"  y1="18" x2="21" y2="18" />
          <line x1="3"  y1="6"  x2="3.01" y2="6"  />
          <line x1="3"  y1="12" x2="3.01" y2="12" />
          <line x1="3"  y1="18" x2="3.01" y2="18" />
        </svg>
        <span className="ml-header-title">Legenda</span>
        <button
          className="ml-header-toggle"
          onClick={() => setCollapsed((v) => !v)}
          title={collapsed ? 'Expandir' : 'Recolher'}
        >
          <svg
            width="12" height="12" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" strokeWidth="2.5"
            strokeLinecap="round" strokeLinejoin="round"
            style={{ transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </div>

      {/* Accordion list */}
      {!collapsed && (
        <div className="ml-list">
          {visibleLayers.map((layer, idx) => (
            <React.Fragment key={layer.id}>
              {idx > 0 && <div className="ml-divider" />}
              <LegendItem layer={layer} />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default MapLegend;
